module.exports = __webpack_public_path__ + "img/logo_icon_white.ee718bd.svg";